'use client';

import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Button from '@/components/common/ui/buttons/Button';
import ButtonNormal from '@/components/common/ui/buttons/ButtonNormal';
import Descriptions from '@/components/common/ui/details/Descriptions';
import DetailsSlider from '@/components/common/ui/details/DetailsSlider';
import SocialShare from '@/components/common/ui/social/SocialShare';
import InnerBannerDetailsSub from '@/components/common/ygen/sections/inner-banner-details-sub/InnerBannerDetailsSub';
import Instruments from '@/components/common/ygen/sections/instruments/Instruments';
import ProductDetailPanel from '@/components/common/ygen/sections/product-detail/ProductDetailPanel';
import Quote from '@/components/common/ygen/sections/quote/Quote';
import { theme } from '@/components/features/theme/theme';
import getProductCategory from '@/public/json/category_list.json';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import Modal from 'react-bootstrap/Modal';
import reactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { sanitizeHtml, createHtmlTransform } from '@/core/lib/htmlSanitizer';

const RenderedSectionProduct = ({ data, category, impact, productDetails, productData, productCategoryData, blogBody = false, breadcrumbTitle = 'Impact Stories', breadcrumbHref = '/impact-stories' }) => {
	let sections_list = data?.posts?.list
		? data.posts.list.filter(f => f?.data?.status === 1)
		: [];
	sections_list = sections_list.length ? sections_list : data?.sections || [];
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [getCategoryData, setCategoryData] = useState(null);

	// Create transform function for safe HTML parsing
	const htmlTransform = createHtmlTransform();

	// Safe HTML parser wrapper
	const safeParse = (html) => {
		if (!html) return null;
		if (typeof html !== 'string') return html;
		const sanitized = sanitizeHtml(html);
		return reactHtmlParser(sanitized, { transform: htmlTransform });
	};

	useEffect(() => {
		if (window.location.hash === '#get-a-quote') {
			setModalIsOpen(true);
		}
	}, []);
	const bannerImage = data?.images?.list
		? data?.images?.list?.find(f => f?.banner === 'on')
		: data?.images?.find(f => f?.banner === 'on');
	const icon = data?.images?.list?.find(f => f?.icon === 'on');
	const router = useRouter();

	const handleBack = () => {
		router.back(); // Navigates back to the previous page
	};
	useEffect(() => {
		if (getProductCategory) {
			const onlyProducts = getProductCategory.find(
				item => item?.id == parseInt(data?.product_data?.category_id),
			);
			setCategoryData(onlyProducts);
		}
	}, [getProductCategory, setCategoryData]);
	const thumb = data?.images?.list?.find(f => f?.thumb === 'on');
	const siemens = data?.categories?.list?.find(f => f?.id === 19);

	return (
		<StyledBlogHeaderProuduct>
			{!category && (
				<InnerBannerDetailsSub
					breadcrumbTitle={breadcrumbTitle}
					breadcrumbHref={breadcrumbHref}
					mainData={data}
					icon={icon?.full_path}
					impact
					title={data?.product_data?.title || data?.page_data?.title}
					short_desc={
						data?.product_data?.short_desc ||
						data?.page_data?.short_desc
					}
					image={bannerImage?.full_path}
				/>
			)}

			{category && (
				<StyledBlogHeader
					data-scroll-section
					className="header-blog-details">
					<Container>
						<Row>
							<Col md={3}>
								<div className="go-back" onClick={handleBack}>
									<Button
										goBack
										color={'#152637'}
										background={'#152637'}
										pathColor={'#fff'}
										text={'Go Back'}
										src={false}
									/>
									<br />
								</div>
							</Col>
							<Col
								md={9}
								className={'d-flex justify-content-end'}>
								<ul className={'d-flex breadcrumb-ygen'}>
									<li>
										<Link href={'/'}>Home</Link>
									</li>
									<li>/</li>
									{impact && (
										<>
											<li>
												<Link href={breadcrumbHref}>
													{breadcrumbTitle}
												</Link>
											</li>
											<li>/</li>
										</>
									)}
									{category && !impact && (
										<>
											<li>
												<Link href={'/products'}>
													Products
												</Link>
											</li>
											<li>/</li>
										</>
									)}

									{getCategoryData && (
										<>
											<li>
												<Link
													href={`/product/${getCategoryData?.slug}`}>
													{getCategoryData?.title}
												</Link>
											</li>
											<li>/</li>
										</>
									)}

									<li>
										<span aria-current="page">
											{data?.product_data?.title
												? data?.product_data?.title
												: data?.page_data?.title
													? data?.page_data?.title
													: ''}
										</span>
									</li>
								</ul>
							</Col>
						</Row>
					</Container>
				</StyledBlogHeader>
			)}

			<StyledBlogDetails
				className={`blog_details ${productDetails ? 'product_details' : ''}`}
				data-scroll-section>
				<Container>
					<Row>
						<Col md={8} className={'blog_details__right'}>
							{category && (
								<>
									<div className="category_header">
										<div
											className={`d-flex ${productDetails ? 'impact' : ''}`}>
											{category && !impact && (
												<div className="single-item">
													<div className="item-image">
														<img
															src={
																thumb?.full_path
															}
															alt={
																typeof data?.product_data?.title === 'string'
																	? data.product_data.title.replace(/<[^>]*>/g, '')
																	: (data?.product_data?.title || 'Product')
															}
														/>
													</div>
												</div>
											)}

											<div
												className={`content ${impact ? 'impact' : ''}`}>
												{data?.product_data?.title && (
													<>
														<div className="single-content">
															<p>Name</p>
															<p>
																{safeParse(
																	data
																		?.product_data
																		?.title,
																)}
															</p>
														</div>
													</>
												)}

												{data?.page_data?.subtitle && (
													<>
														<div className="single-content">
															<p>Clients Name</p>
															<p>
																{safeParse(
																	data
																		?.page_data
																		?.subtitle,
																)}
															</p>
														</div>
													</>
												)}

												{data?.product_data?.area && (
													<>
														<div className="single-content">
															<p>Brand</p>
															<p>
																{safeParse(
																	data
																		?.product_data
																		?.area,
																)}
															</p>
														</div>
													</>
												)}

												{data?.page_data
													?.short_desc && (
													<>
														<div className="single-content">
															<p>
																{safeParse(
																	'Category',
																)}
															</p>
															<p>
																{safeParse(
																	data
																		?.page_data
																		?.short_desc,
																)}
															</p>
														</div>
													</>
												)}

												{getCategoryData?.title && (
													<>
														<div className="single-content">
															<p>
																Product Category
															</p>
															<p>
																{safeParse(
																	getCategoryData?.title,
																)}
															</p>
														</div>
													</>
												)}

												{data?.page_data
													?.description && (
													<>
														<div className="single-content">
															<p>Year</p>
															<p>
																{safeParse(
																	data
																		?.page_data
																		?.description,
																)}
															</p>
														</div>
													</>
												)}
											</div>
										</div>
									</div>
									<div className="category_description">
										<h1>{data?.product_data?.title}</h1>
										{safeParse(
											data?.product_data?.short_desc,
										)}
										<div className="image-wrapper">
											{bannerImage && (
												<img
													src={bannerImage?.full_path}
													alt={
														data?.product_data
															?.title
													}
												/>
											)}
											<p>{bannerImage?.short_title}</p>
										</div>
										{safeParse(
											data?.product_data?.description,
										)}
									</div>
								</>
							)}

							{sections_list?.length > 0 &&
								sections_list.map((item, index) => {
									switch (
										item?.data?.template ||
										item?.section_data?.template
									) {
										case 'description':
											return (
												<Descriptions
													blogBody={blogBody}
													data={item}
													key={index}
												/>
											);
										case 'details_slider':
											return (
												<DetailsSlider
													data={item}
													key={index}
												/>
											);
										default:
											return null;
									}
								})}
						</Col>
						<Col
							md={{ span: 3, offset: 1 }}
							className={'blog_details__left'}
							id={'blog_details'}>
							<div
								className="content-wrapper"
								data-scroll
								data-scroll-sticky
								data-scroll-offset={'-200, 100'}
								data-scroll-target="#blog_details">
								<SocialShare title={blogBody ? data?.page_data?.title : undefined} />

								{!blogBody && (
									<ProductDetailPanel
										productData={data?.product_data}
										specifications={
											Array.isArray(data?.specifications)
												? data.specifications
												: data?.specifications?.list || []
										}
										files={
											Array.isArray(data?.files)
												? data.files
												: data?.files?.list || []
										}
										onRequestQuote={() => setModalIsOpen(true)}
									/>
								)}

								{productDetails
									? null
									: icon && (
											<img
												className={'icon'}
												alt={data?.product_data?.title}
												src={icon?.full_path}
											/>
										)}
							</div>

							{siemens && (
								<div className="d-flex justify-content-start flex-column footer-social">
									<div className="partner-logo d-flex">
										<div className="single-box-content single-box">
											<p>Approved Part</p>
											<p>Automation Drives</p>
										</div>
										<div className="single-box  border-black">
											<img
												src={
													'/images/dynamic/siemens.svg'
												}
												alt={'Siemens'}
											/>
										</div>
									</div>
								</div>
							)}
						</Col>
					</Row>
				</Container>
				<Modal
					className={'modal-video'}
					show={modalIsOpen}
					onclick={() => {
						setModalIsOpen(false);
						window.location.hash = ''; // fallback method
					}}>
					<Modal.Body className={'video'}>
						<Quote
							interest={
								data?.product_data?.title
									? data?.product_data?.title
									: data?.page_data?.title
							}
							onclick={() => {
								setModalIsOpen(false);
								window.location.hash = ''; // fallback method
							}}
						/>
					</Modal.Body>
				</Modal>
			</StyledBlogDetails>
			{sections_list?.length > 0 &&
				sections_list.map((item, index) => {
					switch (item?.data?.template) {
						case 'instruments':
							return (
								<Instruments
									getProductDataJson={productData}
									getProductCategory={productCategoryData}
									parentProduct={data?.product_data?.id}
									data={item}
									key={index}
									slug={data?.product_data?.slug}
								/>
							);
						default:
							return null;
					}
				})}
		</StyledBlogHeaderProuduct>
	);
};
const StyledBlogHeaderProuduct = styled.section`
	.instruments-list {
		&:nth-child(odd) {
			background: #efefef;
		}
	}
`;
const StyledBlogDetails = styled.section`
	padding: 40px 0 120px;
	position: relative;
	font-weight: 400;
	font-size: 1rem; /* 16px */
	line-height: 1.5rem; /* 24px */
	letter-spacing: 0;
	margin-bottom: 20px;

	a {
		color: #dd223f;
		text-decoration: underline;
	}
	h4,
	h5 {
		margin-bottom: 15px;
	}
	h2 {
		font-size: 2rem;
		font-weight: 500;
		line-height: 2.25rem;
	}
	.partner-logo {
		gap: 10px;
		margin-top: 30px;
		width: 100%;
		.single-box {
			width: calc(50% - 10px);
			min-height: 120px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex: 0 0 calc(50% - 10px);
			background-color: white;
			&.border-black {
				border: 1px solid black;
			}

			img {
				height: 90px;
			}
			&.single-box-content {
				background-color: #9f9f9f;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: flex-start;
				padding: 15px;

				p {
					font-size: 1.1rem;
					color: white;
				}
			}
		}

		@media (max-width: 767px) {
			.single-box {
			}
		}
	}
	.partner-logo-yo {
		margin-top: 15px;
		img {
			height: 25px;
		}
	}

	p {
		span {
			color: #dd223f;
		}
	}

	h3 {
		span {
			color: #dd223f;
		}
	}

	.category_description {
		margin-top: 60px;

		h3 {
			margin-bottom: 20px;
		}

		p {
			font-weight: 400;
			font-size: 1rem; /* 16px */
			line-height: 1.5rem; /* 24px */
			letter-spacing: 0;
			margin-bottom: 20px;

			span {
				color: #dd223f;
			}
		}

		.image-wrapper {
			margin-top: 40px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: auto;
				border-radius: 10px;
			}

			p {
				margin-top: 20px;
				font-weight: 500;
			}
		}

		.round-list {
			margin-top: 40px;
			list-style: none;

			li {
				border-bottom: 1px solid rgba(21, 38, 55, 0.2);
				padding-bottom: 10px;
				margin-bottom: 10px;
				color: #152637;
				font-weight: 400;
				font-size: 1rem; /* 16px */
				line-height: 1.5rem; /* 24px */
				letter-spacing: 0em; /* 0% */
				position: relative;
				counter-increment: count;
				padding-left: 32px;
				list-style: none;

				h3 {
					font-weight: 500;
					font-size: 1.25rem; /* 20px */
					line-height: 1.5rem; /* 24px */
					letter-spacing: 0;
					margin-bottom: 10px;
				}

				p {
					margin: 0;
				}

				&:before {
					width: 20px;
					height: 20px;
					background: #dd223f;
					content: counter(count, decimal);
					font-weight: 400;
					font-size: 0.625rem; /* 10px */
					line-height: 0.75rem; /* 12px */
					letter-spacing: 0;
					text-align: center;
					position: absolute;
					color: white;
					left: 0;
					top: 5px;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}

		ul {
			list-style: disc;
			padding-left: 15px;
			margin-bottom: 40px;

			li {
				list-style: disc;
				font-size: 1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 1.53rem;
				letter-spacing: -0.023rem;
				margin-bottom: 10px;

				::marker {
					color: #dd223f;
				}

				&:last-child {
					margin-bottom: 0;
				}
			}
		}

		table {
			width: 100%;
			border-collapse: collapse;
			font-weight: 400;
			font-size: 1rem; /* 16px */
			line-height: 1.5rem; /* 24px */
			letter-spacing: 0;
			color: #394149;
			margin-bottom: 40px;
		}

		tr {
			display: flex;
		}

		th,
		td {
			width: 50%; /* Each cell takes 50% */
			border-bottom: 1px solid rgba(21, 38, 55, 0.2); /* Light gray border */
			padding: 20px 0 20px;
			text-align: left;
		}

		th {
			font-weight: 700;
			padding-top: 0;
			border-bottom: 1px solid #152637; /* Light gray border */
		}

		tr:nth-child(even) {
		}

		tr:hover {
		}
	}

	.category_header {
		.d-flex {
			gap: 30px;
			@media (max-width: 767px) {
				flex-direction: column !important;
			}

			.content {
				&.impact {
					width: 100%;
					display: flex;
					gap: 45px;
					border-bottom: 1px solid #15263780;
					padding-bottom: 20px;
					@media (max-width: 767px) {
						flex-direction: column;
						gap: 0;
					}
				}
			}

			.single-content {
				margin-bottom: 25px;

				&:last-child {
					margin-bottom: 0;
				}

				p {
					&:last-child {
						font-weight: 700;
					}
				}
			}
		}

		.single-item {
			position: relative;
			background: #ffffff;
			border-radius: 5px;
			overflow: hidden;
			border: 1px solid rgba(21, 38, 55, 0.5);
			padding: 45px 30px;

			.item-image {
				position: relative;
				align-items: center;
				justify-content: center;
				display: flex;
				width: 250px;
				height: 200px;
			}
		}
	}

	.icon {
		margin-top: 30px;
		height: 60px;
		display: inline-block;
	}

	&:after {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 300px;
		background: linear-gradient(180deg, #fffdfa 0%, #eee4d9 100%);
		content: '';
		z-index: -1;
		display: none;
	}

	.blog_details__left {
		.back {
			margin-bottom: 20px;

			svg {
				width: 8px;
				height: 8px;
				flex-shrink: 0;
			}

			a {
				color: #bb9753;
				font-size: 0.7rem;
				font-style: normal;
				font-weight: 600;
				line-height: 1rem;
				letter-spacing: -0.021rem;

				span {
					display: inline-flex;
					align-items: center;
					gap: 5px;
				}
			}
		}

		.heading {
			h1 {
				color: #303030;
				font-size: 2.4rem;
				font-style: normal;
				font-weight: 500;
				line-height: 2.616rem;
				letter-spacing: -0.072rem;
				font-family: ${theme.fonts.body};
				margin-bottom: 20px;
			}

			ul {
				display: flex;

				li {
					position: relative;
					font-size: 0.7rem; /* 14px / 20px = 0.7rem */
					font-style: normal;
					font-weight: 400;
					line-height: 1rem; /* 20px / 20px = 1rem */
					color: #534d40;

					span {
						margin: 0 3px;
					}
				}
			}

			margin-bottom: 30px;
		}
	}

	.blog_details__right {
		.banner_image_wrapper {
			margin-bottom: 45px;
			padding-top: calc(380 / 750 * 100%);
			position: relative;
		}

		p {
			color: #394149;
			font-size: 1rem;
			font-style: normal;
			font-weight: 400;
			line-height: 1.53rem;
			letter-spacing: -0.023rem;
		}
	}

	@media (max-width: 767px) {
		padding-top: 120px;
		&.product_details {
			padding-top: 80px;
		}

		.social-list-wrap-div {
			margin-bottom: 30px;
		}
	}
`;
const StyledBlogHeader = styled.section`
	padding: 100px 0 40px;

	.breadcrumb-ygen {
		display: flex;
		gap: 10px;

		li {
			font-size: 1rem; /* 16px / 16 */
			font-style: normal;
			font-weight: 500;
			line-height: 1.5rem; /* 24px / 16 */
			color: #15263780;

			&:last-child {
				color: #152637;

				a {
					color: #152637;
				}
			}

			a {
				font-size: 1rem; /* 16px / 16 */
				font-style: normal;
				font-weight: 500;
				line-height: 1.5rem; /* 24px / 16 */
				color: #15263780;
			}

			h1 {
				font-size: 1rem; /* 16px / 16 */
				font-style: normal;
				font-weight: 500;
				line-height: 1.5rem; /* 24px / 16 */
				color: white;
			}
		}
	}

	.container {
		.row {
			position: relative;

			&:after {
				margin: 0 auto;
				position: absolute;
				bottom: 0;
				left: 15px;
				height: 1px;
				background: #15263780;
				content: '';
				width: calc(100% - 15px);
			}
		}
	}

	.fixed-left {
		z-index: -1 !important;
	}
`;

export default React.memo(RenderedSectionProduct);
